// rspack/webpack runtime global: the resolved public path for emitted assets
// (the dev-server host in development, `/packs/` in production). The pdf.js
// worker, cmaps and standard fonts are copied under `pdfjs/` by CopyRspackPlugin
// (see config/rspack/rspack.config.js), so they are served same-origin.
//
// Serving from our own origin is required by the public onboard portal, which
// enforces a strict CSP (`script-src`/`connect-src` 'self'). The previous
// unpkg.com URLs were blocked by that policy ("Failed to fetch dynamically
// imported module"). It also removes a third-party runtime dependency from the
// candidate contract-signing flow.
// eslint-disable-next-line @typescript-eslint/naming-convention, no-underscore-dangle
declare const __webpack_public_path__: string;

interface PdfDocumentOptions {
  disableFontFace: boolean;
  cMapPacked: boolean;
  cMapUrl: string;
  standardFontDataUrl: string;
}

const pdfJsAssetBaseUrl = (): string => {
  const publicPath = typeof __webpack_public_path__ === 'string' ? __webpack_public_path__ : '';
  const base = publicPath.endsWith('/') ? publicPath : `${publicPath || '/packs'}/`;
  return `${base}pdfjs/`;
};

export const getPdfJsWorkerSrc = (): string => `${pdfJsAssetBaseUrl()}pdf.worker.min.mjs`;

export const getPdfJsDocumentOptions = (): PdfDocumentOptions => ({
  disableFontFace: true,
  cMapPacked: true,
  cMapUrl: `${pdfJsAssetBaseUrl()}cmaps/`,
  standardFontDataUrl: `${pdfJsAssetBaseUrl()}standard_fonts/`
});

export const resolvePdfJsWorkerSrc = (currentWorkerSrc: string | undefined): string =>
  currentWorkerSrc?.trim() ? currentWorkerSrc : getPdfJsWorkerSrc();
